import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  CircularProgress,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { User } from "lib/features/user/types";
import { useState } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: { xs: "90%", sm: "680px" },
  maxHeight: "90%",
  overflowY: "auto",
  width: { xs: "90%", md: "680px" },
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "5px",
  margin: "0px 0px",
  p: { xs: 2, md: 5 },
};

interface CustomerModalProps {
  open: boolean;
  close: () => void;
  customStyle?: object;
  sx?: object;
}

export default function IssueRefundModal({
  open,
  close,
  customStyle = {},
  sx = {},
}: CustomerModalProps) {
  // Form state management
  const [refundType, setRefundType] = useState("Partial");
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [amountError, setAmountError] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);

  const userData = localStorage.getItem("user") as string;
  const parsedUserObject = JSON.parse(userData) as User | undefined;
  const userId = parsedUserObject?.id;

  const handleSubmit = async () => {
    // Validate amount field
    if (!amount || isNaN(Number(amount)) || Number(amount) <= 0) {
      setAmountError(true);
      return;
    }

    setLoading(true);
    try {
      // Add your submission logic here
      setIsConfirmed(true);
    } catch (error) {
      console.error("Error occurred:", error);
    } finally {
      setLoading(false);
      // close();
    }
  };

  return (
    <Modal
      open={open}
      onClose={close}
      aria-labelledby="customer-modal-title"
      aria-describedby="customer-modal-description"
      sx={{ ...sx }}
    >
      <Box sx={{ ...style, ...customStyle }}>
        {isConfirmed ? (
          <>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography
                variant="h6"
                id="extra-charge-modal-title"
                fontWeight="bold"
                sx={{ fontSize: "32px" }}
              >
                Refund Successful
              </Typography>

              <Box sx={{ backgroundColor: "#E8E8EB", borderRadius: "25px" }}>
                <IconButton
                  onClick={() => {
                    close();
                    setIsConfirmed(false);
                    setAmount("");
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>

            <Box sx={{ margin: "25px 0px" }}>
              <Typography
                sx={{ color: "#0D0D0D", fontSize: "20px", fontWeight: "600" }}
              >
                Partial refund of ${amount} issued successfully
              </Typography>
            </Box>
          </>
        ) : (
          <>
            {/* Modal Header */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography
                variant="h6"
                id="extra-charge-modal-title"
                fontWeight="bold"
                sx={{ fontSize: "32px" }}
              >
                Issue Refund
              </Typography>
              <Box sx={{ backgroundColor: "#E8E8EB", borderRadius: "25px" }}>
                <IconButton onClick={close}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>

            {/* Modal Body */}
            <Box mt={2}>
              {/* Select Refund Type */}
              <Box mb={2}>
                <Typography sx={{ fontWeight: "bold", marginBottom: "4px" }}>
                  Select Refund Type
                </Typography>
                <Select
                  fullWidth
                  variant="outlined"
                  value={refundType}
                  onChange={(e) => setRefundType(e.target.value as string)}
                >
                  <MenuItem value="Partial">Partial</MenuItem>
                  <MenuItem value="Full">Full</MenuItem>
                </Select>
              </Box>

              {/* Amount Field */}
              <Box mb={2}>
                <Typography sx={{ fontWeight: "bold", marginBottom: "4px" }}>
                  Amount
                </Typography>
                <TextField
                  fullWidth
                  placeholder="$23"
                  value={amount}
                  error={amountError}
                  helperText={amountError ? "Please enter a valid amount" : ""}
                  onChange={(e) => {
                    setAmount(e.target.value);
                    setAmountError(false); // Reset error on change
                  }}
                />
              </Box>
            </Box>

            {/* Modal Footer */}
            <Box mt={2} display="flex" justifyContent="flex-start">
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={loading}
                sx={{ width: "130px" }}
              >
                {loading ? (
                  <CircularProgress sx={{ color: "white" }} size={24} />
                ) : (
                  "Confirm"
                )}
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
}
